module.exports = __webpack_public_path__ + "img/newicon.e44be4ca.svg";